import React, { useContext } from 'react';
import { number } from 'prop-types';

// utils
import { useUserRolePermissions } from 'hooks';

// Context
import { DrawerContext } from 'common/drawer/DrawerContext';

// Components
import Button from '@mui/material/Button';
import EditPanel from '../../../edit-panel/EditPanel.connector';

const buttonStyles = { margin: theme => theme.spacing(1, 'auto', 0) };

const CardFooter = ({ productId, locationId }) => {
  const { setDrawerComponentProps } = useContext(DrawerContext);

  const { isProductLoadingManage } = useUserRolePermissions();

  const handleClick = () => {
    setDrawerComponentProps({
      Component: props => <EditPanel {...props} locationId={locationId} productId={productId} />,
      forceCloseSelector: () => {},
    });
  };

  return (
    <Button onClick={handleClick} sx={buttonStyles}>
      {isProductLoadingManage ? 'Edit' : 'View'}
    </Button>
  );
};

export default CardFooter;

CardFooter.propTypes = {
  locationId: number.isRequired,
  productId: number.isRequired,
};
